module.exports = __webpack_public_path__ + "static/org_esg_data_convergence-dd08a8a4847668f2b2aff7ec4927ba13.png";